import React, { createRef, useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import AddPersonForm from "../../components/PersonList/AddPersonForm";
import "./PersonList.css";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import { useDispatch, useSelector } from "react-redux";
import PersonTable from "../../components/PersonList/PersonTable";
import {
  addPersonToList,
  deletePerson,
  editPerson,
  getPersonList
} from "../../redux/actions/personListAction";
import Sidebar from "../../components/PersonList/Sidebar";
import moment from "moment";
import { getOrderById } from "../../../Executorship/Order/redux/actions/orderCard";

const PersonList = ({ match, history }) => {
  const formRef = createRef();
  const dispatch = useDispatch();
  const orderId = match.params.id;
  const personTypeKey = match.params.key;

  const order = useSelector(state => state.Executorship.Orders.orderCard.data);

  const personsData = useSelector(state => state.Lists.personList.persons);
  const updated = useSelector(state => state.Lists.personList.updated);
  const buttonLoading = useSelector(
    state => state.Lists.personList.buttonLoading
  );
  const tableLoading = useSelector(
    state => state.Lists.personList.tableLoading
  );

  const [formShown, toggleFormShown] = useState(false);
  const [editingPersonInfo, toggleEditingPersonInfo] = useState(false);
  const [currentPerson, setCurrentPerson] = useState(null);

  const passengersCount =
    personTypeKey === "children"
      ? order && order.kidsCount
      : personTypeKey === "attendants"
      ? order && order.accompCount
      : personTypeKey === "shippingorg"
      ? order && order.workersCount
      : personTypeKey === "med"
      ? order && order.medWorkersCount
      : order && order.passengersCount;
  const responsible = order && order.responsible;
  const responsibleId =
    order && order.responsible && order.responsible.profileId;
  const driver = order && order.driver;
  const driverId = order && order.driverId;
  const vehicleId = order && order.vehicleId;
  const vehicle = order && order.vehicle;
  const orderStatusName = order && order.orderStatusName;
  const arrivalDatetime = order && order.arrivalDatetime;
  useEffect(() => {
    initCaption();
  }, [order]);

  useEffect(() => {
    dispatch(getOrderById(orderId));
    dispatch(getPersonList(orderId, null, null, personTypeKey));
  }, [orderId]);

  useEffect(() => {
    if (currentPerson) {
      const currentPersonInfo = personsData.data.find(person => {
        return person.person_id === currentPerson.person_id && person;
      });
      if (formRef && editingPersonInfo) {
        formRef.current.form.setFieldsValue({
          sex:
            currentPersonInfo &&
            currentPersonInfo.sex &&
            currentPersonInfo.sex.sex_key,
          last_name: currentPersonInfo.second_name,
          first_name: currentPersonInfo.first_name,
          middle_name: currentPersonInfo.middle_name,
          phone_code: currentPersonInfo.phone_code,
          phone_number: currentPersonInfo.phone_number,
          birth_date:
            currentPersonInfo.birth_date &&
            moment(currentPersonInfo.birth_date),
          citizenship: currentPersonInfo.citizenship,
          acbpdp_need: !!currentPersonInfo.acbpdp_need,
          identity_document:
            (currentPersonInfo.identity_document &&
              currentPersonInfo.identity_document.identity_document_key) ||
            undefined,
          identity_document_series: currentPersonInfo.identity_document_series,
          identity_document_num: currentPersonInfo.identity_document_num
        });
      }
    }
  }, [editingPersonInfo, currentPerson]);

  useEffect(() => {
    setCurrentPerson(null);
  }, [updated]);

  const handleAddPersonFormSubmit = values => {
    if (editingPersonInfo) {
      dispatch(
        editPerson({ ...values, orderId, person_id: currentPerson['person_id'], personTypeKey })
      );
    } else {
      dispatch(addPersonToList({ ...values, orderId, personTypeKey }));
    }
  };

  const initCaption = () => {
    const orderNumber =
      order &&
      order.number &&
      order.number.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);

    dispatch(
      setCaption({
        enabled: true,
        mainCaption:
          personTypeKey === "children"
            ? "Список детей"
            : personTypeKey === "attendants"
            ? "Список сопровождающих"
            : personTypeKey === "shippingorg"
            ? "Список работников и/или физ. лиц"
            : personTypeKey === "med"
            ? "Список мед. работников"
            : "Список пассажиров",
        breadCrumbs: [
          {
            path: "/control-panel",
            breadcrumbName: "Панель управления"
          },
          { path: "/executorship/order", breadcrumbName: "Исполнительство" },
          {
            path: "/executorship/order/" + orderId,
            breadcrumbName: "Заказ - " + orderNumber
          }
        ]
      })
    );
  };

  const innerHandleSubmit = () => {
    const values = formRef.current.form.getFieldsValue();
    let filledValues = {};

    for (const key in values) {
      if (values[key] !== undefined) {
        filledValues[key] = values[key];
      }
    }

    handleAddPersonFormSubmit({ ...filledValues });
  };

  const deletePersonFromList = values => {
    dispatch(deletePerson({ orderId, ...values }));
  };

  const initEditPerson = values => {
    toggleFormShown(true);
    toggleEditingPersonInfo(true);
    setCurrentPerson({ ...values });
  };

  const changeTable = (pagination, _, sorter) => {
    dispatch(getPersonList(orderId, pagination, sorter, personTypeKey));
  };

  const changePageSize = pages => {
    const pagination = {
      pageSize: pages && parseInt(pages),
      total: personsData.total,
      current: personsData.current_page
    };
    dispatch(getPersonList(orderId, pagination, null, personTypeKey));
  };

  const handleCancelButton = () => {
    if (editingPersonInfo) {
      toggleFormShown(false);
      toggleEditingPersonInfo(false);
      formRef.current.form.resetFields();
    } else {
      toggleFormShown(false);
      formRef.current.form.resetFields();
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className={"site-wrapper"}>
      <Row gutter={16} className={"person-cols"}>
        <Col span={18}>
          {formShown && (
            <div className={"person-form-space"}>
              <AddPersonForm
                personTypeKey={personTypeKey}
                wrappedComponentRef={formRef}
                editingPersonInfo={editingPersonInfo}
              />
              <div className={"person-button-wrapper"}>
                <Button
                  type="danger"
                  ghost
                  htmlType={"button"}
                  style={{
                    width: 176,
                    marginRight: 16
                  }}
                  onClick={handleCancelButton}
                >
                  Отмена
                </Button>
                {!editingPersonInfo && (
                  <Button
                    type="primary"
                    htmlType={"submit"}
                    ghost
                    form="add-person-form"
                    onClick={() => {
                      innerHandleSubmit();
                      formRef.current.form.resetFields();
                    }}
                    style={{
                      width: 176,
                      marginRight: 16
                    }}
                    loading={buttonLoading}
                  >
                    Еще пассажир
                  </Button>
                )}
                <Button
                  type="primary"
                  htmlType={"submit"}
                  form="add-person-form"
                  style={{
                    width: 176
                  }}
                  loading={buttonLoading}
                  onClick={() => {
                    innerHandleSubmit();
                    toggleFormShown(false);
                    formRef.current.form.resetFields();
                  }}
                >
                  Сохранить
                </Button>
              </div>
            </div>
          )}
          <PersonTable
            data={personsData}
            onChange={changeTable}
            changePageSize={changePageSize}
            loading={tableLoading}
            deletePersonFromList={deletePersonFromList}
            editPerson={initEditPerson}
            personTypeKey={personTypeKey}
          />
        </Col>
        <Col span={6}>
          <Sidebar
            toggleFormShown={toggleFormShown}
            formShown={formShown}
            personCount={passengersCount}
            currentPersonCount={personsData.total}
            driver={{ driver, driverId }}
            vehicle={{ vehicleId, vehicle }}
            responsible={{ ...responsible, responsibleId }}
            goBack={goBack}
            // creator={creatorId, name, lastname,patronymic}
            // responsible={performerId: 111, name, lastname, patronymic}
            orderStatusName={orderStatusName}
            arrivalDatetime={arrivalDatetime}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PersonList;
